// Console's binding of the shared api client (@retink/web-ui): env-reading
// stays here in app code; the factory carries the dev-proxy/prod cross-origin
// resolution for the identity-owned auth endpoints.
import { createApi } from '@retink/web-ui'

export { ApiError } from '@retink/web-ui'

const ID_URL = import.meta.env['VITE_ID_URL'] ?? 'http://id.retink.test:9010'
/** The tenant application (apps/workspace) — where "enter workspace" lands (cross-host). */
export const WORKSPACE_URL = import.meta.env['VITE_WORKSPACE_URL'] ?? 'http://app.retink.test:9010'
/** Legacy user-facing login page; Console now owns its Microsoft sign-in screen. */
export const USER_SIGN_IN_URL = `${ID_URL.replace(/\/$/, '')}/login`

// The merged-deploy API host (https://api.retink.ai). Unset in dev → relative paths
// → the Vite proxy routes them. The console's API is mounted at /admin on the merged
// Function (apps/api: root.route('/admin', createConsoleApp)) — a FIXED prefix, no
// longer tied to the SPA's static base (the console.retink.ai split moved the SPA to
// root '/'). Shared auth API → ${API_URL}/identity; idUrl stays the login-SPA origin.
const API_URL = import.meta.env['VITE_API_URL'] as string | undefined
const API_PREFIX = '/admin'

export const { api, switchTenant, signOut, identityAuthUrl } = createApi({
  idUrl: ID_URL,
  basePath: API_URL ? `${API_URL}${API_PREFIX}` : undefined,
  identityOrigin: API_URL ? `${API_URL}/identity` : undefined,
})
